import React from 'react';
import { TileSleekComponent } from '../../../shared/components/tileLinkStyled';
import { Grid2 as Grid } from '@mui/material';
import { ILink } from '../../shared.interfaces';

export const TileSleekGridGroup = ({ tileData }: { tileData: ILink[] }) => {
  return (
    <Grid container spacing={4}>
      {tileData.map((item) => (
        <TileSleekComponent
          key={item.imgSrc}
          imgSrc={item.imgSrc}
          altVal={item.altVal}
          tileText={item.tileText}
          toLink={item.toLink}
          disabled={item.disabled}
          subInfo1={item.subInfo1}
          subInfo2={item.subInfo2}
        />
      ))}
    </Grid>
  );
};
